module.exports = __webpack_public_path__ + "site/img/10.9657677e.jpg";